import React from 'react';
import PropTypes from 'prop-types';
import { alpha, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const NetworkPlaybook = ({ content = {} }) => {
  const theme = useTheme();
  const pillars = content.pillars || [];

  return (
    <Box>
      <Typography
        variant="overline"
        color="secondary"
        align="center"
        display="block"
        sx={{ fontWeight: 800, letterSpacing: 1.6, mb: 1 }}
      >
        {content.overline || 'Hoja de ruta'}
      </Typography>
      <Typography
        variant="h3"
        align="center"
        gutterBottom
        sx={{ fontWeight: 800 }}
      >
        {content.title}
      </Typography>
      <Typography
        variant="h6"
        align="center"
        color="textSecondary"
        sx={{ mb: 5, maxWidth: 720, mx: 'auto', fontWeight: 400 }}
      >
        {content.subtitle}
      </Typography>
      <Grid container spacing={2}>
        {pillars.map((pillar) => (
          <Grid item xs={12} sm={6} key={pillar.step}>
            <Box
              data-aos="fade-up"
              sx={{
                height: '100%',
                p: { xs: 2.5, md: 3 },
                borderRadius: 3,
                bgcolor: alpha(theme.palette.common.white, 0.72),
                border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
              }}
            >
              <Typography
                variant="caption"
                sx={{ fontWeight: 800, letterSpacing: 1.4, color: 'secondary.main' }}
              >
                {pillar.step}
              </Typography>
              <Typography variant="h6" sx={{ fontWeight: 800, mt: 1, mb: 1.25 }}>
                {pillar.title}
              </Typography>
              <Typography color="textSecondary" sx={{ lineHeight: 1.7 }}>
                {pillar.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

NetworkPlaybook.propTypes = {
  content: PropTypes.object,
};

export default NetworkPlaybook;
